export default "__VITE_ASSET__CyJNq5t___"